
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from './shared-components/user/user.service';
import { Router } from '@angular/router';
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private auth: UserService,
    private myRoute: Router) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const accessToken = sessionStorage.getItem('accessToken');
    if (accessToken != null && (this.auth.userId !== 0 || (this.auth.userType == 3 && this.auth.studentId != 0)) && this.auth.isLoggedIn) {
      return true;
    } else {
      this.myRoute.navigate(['']);
      return false;
    }
  }
}
